<div class="toast-stack" *ngIf="toasts.length > 0" aria-live="polite" aria-label="Notifications">

  <!-- Front (newest) card — fully interactive -->
  <div class="toast-card" role="alert">
    <div class="toast-header">
      <div class="toast-header-meta">
        <span class="toast-type-label">{{ formatType(toasts[0].notificationType) }}</span>
        <span class="toast-sep" *ngIf="toasts[0].fromDisplay"> &middot; </span>
        <span class="toast-from" *ngIf="toasts[0].fromDisplay">{{ toasts[0].fromDisplay }}</span>
      </div>
      <button class="toast-close" (click)="dismiss(toasts[0].id)" aria-label="Dismiss">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="toast-message">{{ toasts[0].message }}</div>

    <div class="toast-row-bottom">
      <span class="toast-time">{{ formatTime(toasts[0].timestamp) }}</span>
      <button class="dismiss-all-btn" *ngIf="toasts.length > 1" (click)="dismissAll()">
        Dismiss all &bull; {{ toasts.length }}
      </button>
    </div>
  </div>

  <!-- Phantom stacking strips — purely visual depth, no content -->
  <div class="toast-peek toast-peek-1" *ngIf="toasts.length > 1" aria-hidden="true"></div>
  <div class="toast-peek toast-peek-2" *ngIf="toasts.length > 2" aria-hidden="true"></div>

</div>
